<template>
	<div class="v5-loading" v-show="visible">
		<div class="v5-loading-content">
		</div>
	</div>
</template>
<script>
	import debounce from './../../utils/debounce';
	export default {
		name: 'v5-loading',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			delay: {
				type: Number,
				default: 0
			}
		},
		watch: {
			value(val) {
				if (this.visible === val) return;

				this.update();
			},
			visible(val) {
				this.$emit('input', val);
			}
		},
		methods: {
			update() {
				this.visible = this.value;
			}
		},
		created() {
			this.$nextTick(() => {
				//延时展示，减少loading闪烁
				if (this.delay) {
					this.update = debounce(this.update, this.delay);
				}
			});
		},
		data() {
			return {
				visible: this.value
			};
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>



// WEBPACK FOOTER //
// index.vue?c9d8cd06